import { selectors } from 'modules/common';
import { State } from 'modules/data';

import { pageConfig } from '../../config';
import { ActivePopup } from '../reducers/page/activePopupReducer';
import { Page } from '../reducers/pageReducer';

export const getPage = (state: State): Page => {
    return selectors.page.getPage(state, pageConfig.store.id);
};

export const getActivePopup = <T extends ActivePopup = ActivePopup>(state: State): T => getPage(state).activePopup as T;

export const getLoading = (state: State): boolean => getPage(state).loading;
